import { create } from 'zustand'
export const useWalletExpiredBalanceStore = create(set => ({
  dateExpiryStart: null,
  setDateExpiryStart: dateExpiryStart => set(() => ({ dateExpiryStart })),
  dateExpiryEnd: null,
  setDateExpiryEnd: dateExpiryEnd => set(() => ({ dateExpiryEnd })),
  walletExpiredBalanceData: [],
  setWalletExpiredBalanceData: data =>
    set(() => ({ walletExpiredBalanceData: data })),
  resetStore: () =>
    set(() => ({
      dateExpiryStart: null,
      dateExpiryEnd: null,
    })),
}))
